/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

const section9MedicalTypes = [
    MedicalTypeIds.RespiratorySensitiser,
    MedicalTypeIds.RespiratorySensitiserFaceToFaceLevel1,
    MedicalTypeIds.RespiratorySensitiserQuestionnaireLevel1,
    MedicalTypeIds.SafetyCriticalWorker,
    MedicalTypeIds.WorkAtHeight,
    MedicalTypeIds.WorkingConfinedSpaces,
    MedicalTypeIds.WearingRPE,
    MedicalTypeIds.WearingBreathingApparatus,
    MedicalTypeIds.WorkingThermalEnvironment,
    MedicalTypeIds.Offshore,
    MedicalTypeIds.Airside,
    MedicalTypeIds.OtherFitnessToWork,
    MedicalTypeIds.LAAWorker
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
export const section9Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.DoYouSmoke,
        questionText: "Do you smoke?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.HowManySmokePerDay,
        questionText: "Please state how many per day",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.ExSmoker,
        questionText: "Are you an ex-smoker?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.ExSmokerWhenQuitAndHowManySmokePerDay,
        questionText: "Please state when you quit and how many you used to smoke",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.AnyMedicationAsthmaOtherRespiratoryConditions,
        questionText: "Do you take any medication for asthma or other respiratory conditions?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.AnyMedicationAsthmaOtherRespiratoryConditionsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.DrinkAlcohol,
        questionText: "Do you drink alcohol?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.DrinkAlcoholNumberOfUnitsPerWeek,
        questionText: "Please state approx. units consumed per week",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.Exercise,
        questionText: "Do you exercise?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.ExerciseHoursPerWeek,
        questionText: "Please state approx. hours per week",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingAsthma,
        questionText: "Asthma",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingAsthmaSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingAsthmaSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingAsthmaFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingBronchitis,
        questionText: "Bronchitis",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingBronchitisSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingBronchitisSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingBronchitisFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingTuberculosis,
        questionText: "Tuberculosis",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingTuberculosisSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingTuberculosisSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingTuberculosisFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingDryCough,
        questionText: "Dry cough / cough phlegm",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingDryCoughSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingDryCoughSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingDryCoughFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingChestTightness,
        questionText: "Chest tightness",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingChestTightnessSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingChestTightnessSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingChestTightnessFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingRecurringSorenessWateringOfEyes,
        questionText: "Recurring soreness or watering of eyes",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingRecurringSorenessWateringOfEyesSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingRecurringSorenessWateringOfEyesSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingRecurringSorenessWateringOfEyesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingWorkRelatedBreatingProblems,
        questionText: "Work related breathing problems",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingWorkRelatedBreatingProblemsSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingWorkRelatedBreatingProblemsSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingWorkRelatedBreatingProblemsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingCancer,
        questionText: "Cancer",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingCancerSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingCancerSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingCancerFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingChestInjury,
        questionText: "Chest injury or operation",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingChestInjurySymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingChestInjurySymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingChestInjuryFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingBreathlessness,
        questionText: "Breathlessness",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingBreathlessnessSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingBreathlessnessSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingBreathlessnessFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingWheezing,
        questionText: "Wheezing",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingWheezingSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingWheezingSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingWheezingFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingRecurringBlockedRunningNose,
        questionText: "Recurring blocked or running nose",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingRecurringBlockedRunningNoseSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingRecurringBlockedRunningNoseSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
        medicalTypes: section9MedicalTypes
    },
    {
        id: questionIds.CurrentlySufferingRecurringBlockedRunningNoseFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section9MedicalTypes
    }
];
/* eslint-enable max-len */
